import { isEqual } from 'lodash-es';

/**
 * The job fields "All jobs in this run" can carry from the edited job onto the rest of the run.
 * `startTime` is the typed HH:mm and `resources` the requested resource rows; everything else is
 * copied as-is.
 */
export const RUN_APPLIED_FIELDS = [
    'foremenId',
    'requestedById',
    'projectManagerId',
    'projectName',
    'subcontractorCompanyId',
    'meetingLocation',
    'jobLocation',
    'description',
    'workOrderNumber',
    'dispatchOfficeLocationId',
    'notes',
    'inspectorName',
    'jobTypeId',
    'purchaseOrderNumber',
    'workRequest',
    'startTime',
    'resources',
];

/**
 * The run fields whose value the dispatcher changed in this edit: those that differ between the
 * job as saved and its snapshot from when the form opened. With no snapshot every field counts as
 * changed, which is the whole-record copy the run apply used to do.
 */
export const changedRunFields = (job, originalJob) => new Set(
    RUN_APPLIED_FIELDS.filter((field) => !originalJob || !isEqual(job[field], originalJob[field])),
);

/**
 * What one member of the run receives for `field` when the edited job is applied to the run.
 * The edited job keeps what was typed (a cleared field stays cleared). Every other member takes
 * the edited job's value only when the dispatcher changed that field in this edit and did not
 * leave it blank; otherwise it keeps its own, so a day with its own address, Work Order Number
 * or start time is not reverted by an unrelated edit to another day.
 */
export const applyRunField = (field, updatedJob, member, changedFields, isEditedJob) => {
    const next = updatedJob[field];

    if (isEditedJob) return next ?? member[field];
    if (!changedFields.has(field) || next == null || next === '') return member[field];

    return next;
};
